import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { API } from ':api';
import { CATALOG_CATEGORIES, CATALOG_SERVICES } from ':api/urls';
import { ServiceItem, Categories } from ':types';

type QueryType = {
  items: ServiceItem[];
};

export const useServicesApi = (
  categoryId?: string
): UseQueryResult<QueryType> =>
  useQuery<QueryType>({
    queryKey: ['CatalogServicesList', categoryId],
    queryFn: async () => {
      if (categoryId)
        return (await API.get(`${CATALOG_SERVICES}?category_id=${categoryId}`)).data;
      return (await API.get(CATALOG_SERVICES)).data;
    },
  });

type QueryCategories = {
  items: Categories[];
};

export const useCategoriesApi = (): UseQueryResult<QueryCategories> =>
  useQuery<QueryCategories>({
    queryKey: ['CatalogCategoriesList'],
    queryFn: async () => {
      return (await API.get(CATALOG_CATEGORIES)).data;
    },
  });
